import controller from './breadcrumbs-controller';
import template from './breadcrumbs.html'

const HeaderComponent = {
    bindings: {
        crumbs: '<',
        currentPageName: '<'
    },
    controller,
    template
};

export default HeaderComponent;



// WEBPACK FOOTER //
// ./app/common/breadcrumbs/breadcrumbs-component.js